import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "appeal-single-cont",
    attrs: {
      "confirm-loading": _vm.confirmLoading,
      "data-sign": "product_add_multi_appeal_modal",
      "title": _vm.t('新增申诉'),
      "visible": _vm.modalVisible,
      "width": 1102,
      "okText": _vm.t('common', '提交')
    },
    on: {
      "cancel": _vm.handleCancel,
      "ok": _vm.handleOk
    }
  }, [_c('a-alert', {
    staticClass: "mb-5",
    attrs: {
      "message": _vm.t('中英文申报品名、进口关税税率、品牌每个进口国只能申诉一次；头程类型、海外仓是否可存申诉被驳回之后，支持再次申诉，其他可支持申诉多次。'),
      "type": "warning",
      "show-icon": ""
    }
  }), _c('div', {
    staticClass: "appeal-single-cont__title-cont"
  }, [_c('div', {
    staticClass: "appeal-single-cont__title-cont-label"
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label",
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v(_vm._s(_vm.t('进/出口国（地区）')))]), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label",
    staticStyle: {
      "width": "172px"
    }
  }, [_vm._v(_vm._s(_vm.t('申诉原因')))]), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label"
  }, [_vm._v(_vm._s(_vm.t('申诉前')))]), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.t('申诉后')))]), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label"
  }, [_vm._v(_vm._s(_vm.t('备注')))]), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label"
  }, [_vm._v(" " + _vm._s(_vm.t('相关资料')) + " "), _c('a-tooltip', [_c('template', {
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.fileTipMessage))])]), _c('span', [_c('a-icon', {
    attrs: {
      "type": "question-circle"
    }
  })], 1)], 2)], 1), _c('div', {
    staticClass: "appeal-single-cont__title-cont-label"
  }, [_vm._v(_vm._s(_vm.t('操作')))])]), _c('a-form-model', {
    ref: "formModel",
    attrs: {
      "model": _vm.form,
      "data-sign": "product_add_multi_appeal_form",
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "appeal-single-cont-code"
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "product_sku"
    }
  }, [_c('request-auto-complete', {
    attrs: {
      "max-length": 80,
      "disabled": _vm.isOperationMode,
      "searchFunction": _vm.handleSearchSkuList
    },
    on: {
      "select": function ($event) {
        return _vm.handleQuery($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "dataSource",
      fn: function (ref) {
        var options = ref.options;
        return _vm._l(options, function (item) {
          return _c('a-select-option', {
            key: item.sku,
            attrs: {
              "value": item.sku
            }
          }, [_vm._v(_vm._s(item.sku))]);
        });
      }
    }]),
    model: {
      value: _vm.form.product_sku,
      callback: function ($$v) {
        _vm.$set(_vm.form, "product_sku", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "form.product_sku"
    }
  })], 1)], 1), _c('div', {
    staticClass: "appeal-single-cont-combine"
  }, _vm._l(_vm.form.appeal_list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "appeal-single-cont-combine-item"
    }, [_c('div', {
      staticClass: "ant-row",
      staticStyle: {
        "width": "210px"
      }
    }, [_c('a-form-model-item', {
      staticStyle: {
        "width": "100px",
        "border-right": "0px",
        "display": "inline-block"
      },
      attrs: {
        "prop": "appeal_list[" + index + "].country_type",
        "rules": {
          required: true,
          message: _vm.t('请选择国家（地区）')
        }
      }
    }, [_c('my-select', {
      attrs: {
        "fbu-invalid-analyse-tag": true,
        "disabled": !_vm.form.product_sku || !_vm.skuAvailable || _vm.isOperationMode,
        "placeholder": _vm.t('请选择进出口国类型')
      },
      on: {
        "change": function ($event) {
          return _vm.handleCountryTypeChange(index, arguments[0]);
        }
      },
      model: {
        value: item.country_type,
        callback: function ($$v) {
          _vm.$set(item, "country_type", $$v);
        },
        expression: "item.country_type"
      }
    }, _vm._l(_vm.countryTypeList, function (item) {
      return _c('a-select-option', {
        key: item.value,
        attrs: {
          "value": item.value
        }
      }, [_vm._v(_vm._s(item.text))]);
    }), 1)], 1), _c('a-form-model-item', {
      staticStyle: {
        "width": "100px",
        "border-right": "0px",
        "display": "inline-block"
      },
      attrs: {
        "prop": "appeal_list[" + index + "].country_code",
        "rules": {
          required: true,
          message: _vm.t('请选择国家（地区）')
        }
      }
    }, [_c('my-select', {
      attrs: {
        "disabled": !_vm.form.product_sku || !_vm.skuAvailable || _vm.isOperationMode
      },
      on: {
        "change": function ($event) {
          return _vm.handleCountryChange(index, arguments[0]);
        }
      },
      model: {
        value: item.country_code,
        callback: function ($$v) {
          _vm.$set(item, "country_code", $$v);
        },
        expression: "item.country_code"
      }
    }, _vm._l(_vm.rowCountryList[index] || [], function (item) {
      return _c('a-select-option', {
        key: item.country_code,
        attrs: {
          "value": item.country_code
        }
      }, [_vm._v(_vm._s(item.country_name))]);
    }), 1)], 1)], 1), _c('a-form-model-item', {
      staticStyle: {
        "width": "172px"
      },
      attrs: {
        "prop": "appeal_list[" + index + "].appeal_reason",
        "rules": {
          required: true,
          message: _vm.t('请选择申诉原因')
        }
      }
    }, [_c('my-select', {
      attrs: {
        "disabled": !_vm.form.appeal_list[index].country_code
      },
      on: {
        "change": function ($event) {
          return _vm.handleReasonChange(index, arguments[0]);
        }
      },
      model: {
        value: item.appeal_reason,
        callback: function ($$v) {
          _vm.$set(item, "appeal_reason", $$v);
        },
        expression: "item.appeal_reason"
      }
    }, _vm._l(_vm.rowAppealReasonList[index], function (item) {
      return _c('a-select-option', {
        key: item.value
      }, [_vm._v(_vm._s(item.text))]);
    }), 1)], 1), _c('a-form-model-item', [_vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IMAGE_LIST_EDIT ? _c('div', [_c('preview-files', {
      attrs: {
        "data": _vm.productDetails && _vm.productDetails.image_list ? _vm.productDetails.image_list : [],
        "formatField": "file_name",
        "mapping": {
          file_url: 'preview_url',
          file_path: 'file_path',
          file_name: 'file_name'
        }
      }
    })], 1) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IS_NEED_COMPLIANCE_OFFICER_EDIT ? _c('div', [_vm.rowBeforeAppealList[index] !== undefined ? _c('span', [_vm._v(_vm._s(_vm.rowBeforeAppealList[index] ? _vm.t('是') : _vm.t('否')))]) : _vm._e()]) : _vm.rowBeforeAppealList[index] ? _c('div', [_c('div', {
      staticStyle: {
        "line-height": "20px",
        "margin-top": "10px"
      }
    }, [_c('text-ellipses', {
      attrs: {
        "data": _vm.rowBeforeAppealList[index]
      }
    })], 1)]) : _vm._e()]), _c('a-form-model-item', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "prop": "appeal_list." + index + ".after_appeal",
        "rules": _vm.rules['appeal_list.*.after_appeal']
      }
    }, [_vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IMAGE_LIST_EDIT ? _c('div', [_c('mul-attr-upload', {
      attrs: {
        "api": "product.uploadAttachment",
        "extList": ['JPG', 'JPEG', 'PNG', 'BMP'],
        "maxSize": 5 * 1024 * 1024,
        "maxLen": 10,
        "isNumberSize": false,
        "mapping": {
          file_name: 'customer_file_name',
          file_path: 'path',
          file_size: 'size',
          file_ext: 'file_ext'
        }
      },
      on: {
        "input": function (value) {
          return _vm.handleImageListChange(index, value);
        }
      },
      model: {
        value: _vm.form.appeal_list[index]._image_list,
        callback: function ($$v) {
          _vm.$set(_vm.form.appeal_list[index], "_image_list", $$v);
        },
        expression: "form.appeal_list[index]._image_list"
      }
    })], 1) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT ? _c('my-select', {
      staticClass: "mr-0",
      attrs: {
        "disabled": ""
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", $$v);
        },
        expression: "item.after_appeal"
      }
    }, _vm._l(_vm.headTypeList, function (item) {
      return _c('a-select-option', {
        key: item.value
      }, [_vm._v(_vm._s(item.text))]);
    }), 1) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IS_OVERSEA_WAREHOUSE_STORABLE ? _c('my-select', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", $$v);
        },
        expression: "item.after_appeal"
      }
    }, _vm._l(_vm.boolEnumList, function (item) {
      return _c('a-select-option', {
        key: item.value
      }, [_vm._v(_vm._s(item.text))]);
    }), 1) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.EXPORT_DECLARED_VALUE_EDIT || _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IMPORT_DECLARED_VALUE_EDIT ? _c('a-input-number', {
      attrs: {
        "precision": 2,
        "min": 0,
        "max": 99999999999,
        "step": 0.01
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.after_appeal"
      }
    }) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IMPORT_TARIFF_PCT_EDIT ? [_c('a-tooltip', [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.t('请填写申诉后的海关编码')))]), _c('a-input', {
      attrs: {
        "fbu-invalid-analyse-tag": true,
        "max-length": 10,
        "disabled": !_vm.form.appeal_list[index].appeal_reason,
        "placeholder": _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IMPORT_TARIFF_PCT_EDIT ? _vm.t('请输入6~10位数字') : _vm.t('')
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.after_appeal"
      }
    })], 1)] : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.CN_NAME_EDIT ? _c('a-input', {
      attrs: {
        "max-length": 255,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", $$v);
        },
        expression: "item.after_appeal"
      }
    }) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.EN_NAME_EDIT ? _c('a-input', {
      attrs: {
        "max-length": 255,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", $$v);
        },
        expression: "item.after_appeal"
      }
    }) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.LINK_EDIT ? _c('a-input', {
      attrs: {
        "max-length": 1000,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.after_appeal"
      }
    }) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.BRAND_EDIT ? _c('a-input', {
      attrs: {
        "max-length": 100,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.after_appeal"
      }
    }) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.PURPOSE_EDIT ? _c('a-input', {
      attrs: {
        "max-length": 100,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.after_appeal"
      }
    }) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.MATERIAL_EDIT ? _c('my-select', {
      staticClass: "mr-0",
      attrs: {
        "show-search": "",
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", $$v);
        },
        expression: "item.after_appeal"
      }
    }, _vm._l(_vm.materialList, function (item) {
      return _c('a-select-option', {
        key: item
      }, [_vm._v(_vm._s(item))]);
    }), 1) : _vm.form.appeal_list[index].appeal_reason === _vm.$enum.product.AppealReasonEnum.IS_NEED_COMPLIANCE_OFFICER_EDIT ? _c('span', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.after_appeal !== undefined,
        expression: "item.after_appeal!==undefined"
      }]
    }, [_vm._v(_vm._s(item.after_appeal ? _vm.t('是') : _vm.t('否')))])]) : _c('a-input', {
      attrs: {
        "max-length": 100,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.after_appeal,
        callback: function ($$v) {
          _vm.$set(item, "after_appeal", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.after_appeal"
      }
    })], 2), _c('a-form-model-item', [_c('a-input', {
      attrs: {
        "max-length": 50,
        "disabled": !_vm.form.appeal_list[index].appeal_reason
      },
      model: {
        value: item.appeal_remark,
        callback: function ($$v) {
          _vm.$set(item, "appeal_remark", typeof $$v === 'string' ? $$v.trim() : $$v);
        },
        expression: "item.appeal_remark"
      }
    })], 1), _c('a-form-model-item', [_c('my-upload', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: [_vm.$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT].includes(_vm.form.appeal_list[index].appeal_reason),
        expression: "[$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT].includes(form.appeal_list[index].appeal_reason)"
      }],
      attrs: {
        "multiple": "",
        "validate-type": "ProductAppealRule",
        "data-permission": "product_add_multi_appeal_upload",
        "id": "product_add_multi_appeal_upload",
        "data-sign": "product_add_multi_appeal_upload",
        "data": _vm.fileList[index],
        "before-upload": _vm.uploadRequest
      },
      on: {
        "onTipMessage": _vm.handleUploadFileTipMessage
      }
    }, [_c('a-button', {
      attrs: {
        "type": "link",
        "fbu-analyse-name": $t("\u4E0A\u4F20")
      },
      on: {
        "click": function ($event) {
          _vm.curIndex = index;
        }
      }
    }, [_vm._v(_vm._s(_vm.t('上传')))])], 1), _vm._l(_vm.fileList[index], function (it, idx) {
      return _c('div', {
        key: idx,
        staticClass: "file-yy-list"
      }, [_c('a', {
        attrs: {
          "href": "javascript:;",
          "title": _vm.t('预览'),
          "data-permission": "product_add_multi_appeal_preview",
          "id": "product_add_multi_appeal_preview",
          "data-sign": "product_add_multi_appeal_preview"
        },
        on: {
          "click": function ($event) {
            return _vm.$preview("" + it.preview_url);
          }
        }
      }, [_c('a-icon', {
        staticClass: "mr-3",
        attrs: {
          "type": "eye"
        }
      })], 1), _c('span', [_vm._v(_vm._s(it.file_name))])]);
    })], 2), _c('a-form-model-item', [_vm.form.appeal_list.length !== 1 ? _c('a-button', {
      attrs: {
        "type": "link",
        "data-permission": "product_add_multi_appeal_delete",
        "id": "product_add_multi_appeal_delete",
        "data-sign": "product_add_multi_appeal_delete",
        "fbu-analyse-name": $t("\u5220\u9664")
      },
      on: {
        "click": function ($event) {
          return _vm.handleDelete(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.t('删除')))]) : !_vm.isOperationMode ? _c('a-button', {
      attrs: {
        "type": "link",
        "data-sign": "product_add_multi_appeal_reset",
        "fbu-analyse-name": $t("\u91CD\u7F6E")
      },
      on: {
        "click": _vm.handleClear
      }
    }, [_vm._v(_vm._s(_vm.t('重置')))]) : _vm._e()], 1)], 1);
  }), 0)]), _vm.form.appeal_list[_vm.form.appeal_list.length - 1].appeal_reason ? _c('div', {
    staticClass: "mt-10"
  }, [_c('a', {
    attrs: {
      "data-permission": "product_add_multi_appeal",
      "id": "product_add_multi_appeal",
      "data-sign": "product_add_multi_appeal",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_c('span', [_vm._v("+")]), _vm._v(_vm._s(_vm.t('common', '新增')))])]) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };